import axios from 'axios';
import { useQuery } from 'react-query';

// Resets the user's KYC retry-attempts counter so they can verify again.
// A user locked at RETRY_ATTEMPTS_EXCEEDED is moved back to a retryable
// status; the resulting KYC status string is returned. The Authorization
// token must go in the request config (3rd arg), not the body, or the
// office endpoint rejects the call.
const resetKycVerificationAttempts = async (userId: string) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/office/kyc/reset-verification-attempts/${userId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }
  );
  return data;
};

const useResetKycVerificationAttempts = (userId: string, props = {}) =>
  useQuery(
    ['resetKycVerificationAttempts', { userId }],
    () => resetKycVerificationAttempts(userId),
    {
      enabled: false,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...props
    }
  );

export default useResetKycVerificationAttempts;
